import { Component, input } from '@angular/core';

import { Order } from '../order.model';
import { IconComponent } from '../../../shared/icon/icon.component';

@Component({
  selector: 'app-order-device',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './order-device.component.html',
  styleUrl: './order-device.component.css'
})
export class OrderDeviceComponent {
  readonly order = input.required<Order>();
}
